//Libraries
import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

// Local Libraries
import phrasebookLoad from "../../../i18n";
import * as token from '../../../helpers/token';
import { accountTypesConstants, portalFunctionalityConstants, permissionTypeConst } from '../../../constants';
import { permissionFinder, capitalizeFirstLetter } from "../../../helpers/util"

//Redux
import { carrierActions, vendorActions } from 'actions';

//Componenets
import { Table } from "../../../components/SkyFramework/Tables/Table.jsx";
import { PaginationBar } from "../../../components/SkyFramework/Pagination/PaginationBar.jsx";
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SearchBox } from "../../../components/SkyFramework/Search";


//Routes
import { gisRoutes } from "../../../routes/routes";

// Constants
const phrasebook = phrasebookLoad()

class Carriers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      carriers: undefined,
      filters: { orderby: 'cic', asc: true },
      limit: 10,
      page: 1
    };

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.handleDeleteSubmit = this.handleDeleteSubmit.bind(this);
  }

  componentDidMount() {
    if (token.loggedAccountType() < 200) {
      this.props.dispatch(carrierActions.getAll(this.state.limit, this.state.page - 1, this.state.filters));
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.carriers && prevProps && prevProps.carriers !== this.props.carriers) {
      this.setState({ carriers: this.props.carriers });
    }
  }

  onPageChanged = currentPage => {
    this.setState({ page: currentPage });
    this.props.dispatch(carrierActions.getAll(this.state.limit, currentPage - 1, this.state.filters));
  }

  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    var searchValues = {
      orderby: 'cic',
      asc: true
    };
    this.setState({ filters: searchValues });
    this.props.dispatch(carrierActions.getAll(this.state.limit, 0, searchValues));
  }

  SearchBox() {

    if (this.state.jurisdictions && this.state.cities) {
      if (token.loggedAccountType() < 200 && this.state.customers) {
        const customerOptions = this.state.customers.map(function (customer) {
          return { value: customer['pccwglobal_insight_company_code'] ? customer['pccwglobal_insight_company_code'] : customer['name'], label: capitalizeFirstLetter(customer['name']) };
        });
        var filters = [[{ label: phrasebook.common.customer, type: "select", id: "customer_code", name: "customer_code", options: customerOptions, empty_option: true }, {
          label: phrasebook.numbers.type_of_service,
          type: "select", id: "service_type", tooltip: phrasebook.numbers.type_of_number, name: "service_type", options: this.state.service_types, empty_option: true
        }]]
      } else {
        var filters = [[{
          label: phrasebook.numbers.type_of_service,
          type: "select", id: "service_type", tooltip: phrasebook.numbers.type_of_number, name: "service_type", options: this.state.service_types, empty_option: true
        }]]
      }


      const jurisdictionOptions = this.state.jurisdictions.map(function (jurisdiction) {
        return { value: jurisdiction.jurisdiction, label: jurisdiction.jurisdiction };
      });
      const cityOptions = this.state.cities.map(function (city) {
        return { value: city.city, label: city.city };
      });

      filters.push([
        { label: phrasebook.profile.jurisdiction, type: "select", id: "jurisdiction", tooltip: phrasebook.tooltip.jurisdiction, name: "jurisdiction", options: jurisdictionOptions, empty_option: true },
        { label: phrasebook.references.city, type: "select", id: "city", name: "city", options: cityOptions, empty_option: true },
        {
          label: phrasebook.numbers.service_number,
          type: "text",
          id: "routing_vendor",
          name: "routing_vendor",
        },
        {
          label: `${phrasebook.headerlinks.order} ID`,
          type: "text",
          id: "order_id",
          name: "order_id",
        }],
      );

      return (
        <SearchBox
          filters={filters}
          buttonTitle={phrasebook.common.search}
          onClick={this.handleSearchSubmit}
          onChange={this.handleChange}
        />)
    } else return null;
  }

  canAdd() {
    if (permissionFinder(this.props.loggedpermissions.loggedPermissions, token.loggedAccountType(), portalFunctionalityConstants.management.invnumber, permissionTypeConst.ADD, token.loggedToken())) return <div class="ml-sm-auto mt-1 mt-sm-0">
      {/* <Link to={gisRoutes.management.carrier.add}>
      <button type="button" class="btn btn-main">
        {phrasebook.common.add} {phrasebook.headerlinks.carrier}
      </button>
    </Link><span></span> */}
      <Link to={gisRoutes.management.carrier.bulk}>
        <button type="button" class="btn btn-main">
          {phrasebook.common.bulk} {phrasebook.common.add} {phrasebook.headerlinks.carriers}
        </button>
      </Link>
    </div>
  }

  CarrierList = () => {

    if (this.state.carriers) {
      let labels = [
        'CIC',
        'CS',
        'CLLI_NAME',
      ];
      var fields = ['cic', 'cs', 'clli_name']
      var actions = [];

      // actions.push({
      //   location: gisRoutes.management.carrier.read,
      //   label: phrasebook.common.show,
      //   type: "link",
      // });
      return (<div>
        {this.canAdd()}
        <br></br>
        <Table
          headers={labels}
          keys={fields}
          values={this.state.carriers.data}
          nofound={phrasebook.common.nodatafound}
          actions={actions}
          action_key={'id'} />
        <PaginationBar limit={this.state.limit}
          total={this.state.carriers.count}
          currentPage={this.state.page}
          onPageChanged={this}
          pageNeighbours={this.state.pageNeighbours} />
      </div>)
    } else return null;
  }

  render() {
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }]} current={phrasebook.headerlinks.carriers} />

      <div className="box p-1 p-sm-2">
        <h2 className="box-title pb-1 mb-1">{phrasebook.headerlinks.carriers}</h2>
        {/* {this.SearchBox()} */}

      </div>
      <div className="box p-1 p-sm-2 my-md-1">
        <h3 className="box-title pb-1 mb-1">{phrasebook.headerlinks.carriers}</h3>
        {this.CarrierList()}
      </div>
    </>
  }
}

function mapStateToProps(state) {
  const { authentication, carrier, loggedpermissions } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    carriers: carrier.carriers,

  };
}

const carriers = connect(mapStateToProps)(Carriers);
export default carriers;
